module.exports = __webpack_public_path__ + "/login_ui/img/tn-08449c29de756764eaa1a65784a2babb.svg";